/**
 * Lightweight chat moderation: mask phone numbers and detect abusive content.
 * Used before sending messages; abusive messages are blocked (warn only), phones are masked with ***.
 */

import { Filter } from "bad-words";
import { HINGLISH_LIST_B64 } from "./hinglishList.encoded";

const PHONE_REGEX =
  /(?:\+\d{1,4}[\s\-.]?)?(?:\(?\d{2,4}\)?[\s\-.]?)?\d{3,4}[\s\-.]?\d{3,4}(?:[\s\-.]?\d{2,4})?|\d{7,15}/g;

const profanityFilter = new Filter();

const HINGLISH_ABUSIVE_TOKENS: string[] = JSON.parse(atob(HINGLISH_LIST_B64));

function normalizeForHinglishCheck(text: string): string {
  return text.toLowerCase().replace(/[^\w\s]/g, " ");
}

function containsHinglishAbuse(text: string): boolean {
  const normalized = normalizeForHinglishCheck(text);
  for (const token of HINGLISH_ABUSIVE_TOKENS) {
    const re = new RegExp(`\\b${token.replace(/\W/g, "\\$&")}\\b`, "i");
    if (re.test(normalized) || normalized.includes(token)) return true;
  }
  return false;
}

/**
 * Replaces phone-number-like sequences in text with ***.
 */
export function maskPhoneNumbers(text: string): string {
  if (!text || typeof text !== "string") return text;
  return text.replace(PHONE_REGEX, "***");
}

/**
 * Returns true if the text appears to contain abusive content (English via bad-words + Hinglish list).
 */
export function containsAbusiveContent(text: string): boolean {
  if (!text || typeof text !== "string") return false;
  return profanityFilter.isProfane(text) || containsHinglishAbuse(text);
}
